import toast from "bootstrap/js/src/toast";
import {showErrorMessage} from "@/helper";

export default {
    fetchRecords(batchId, body) {
        return new Promise((resolve, reject) => {
            http.post('api/batches/' + batchId + '/items/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/batches' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    uploadReports() {
        return new Promise((resolve, reject) => {
            http.get('api/batches/run', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getBatch(batchId, style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/batches/' + batchId, {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getProcessingBatch() {
        return new Promise((resolve, reject) => {
            http.get('api/batches/get-processing', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
}